const sharedRoutes = {
    bookings: 'booking',
    profile: 'profile',
    orderHistory: '/order_history',
    editProfile: 'edit_profile',
}
export default sharedRoutes;